import { useOktaAuth } from '@okta/okta-react';
import { useAuthConfig } from './auth-context';

export function useAutoSignIn() {
  const { oktaAuth } = useOktaAuth();
  const hasAccessToApp = useHasAccessToApp();
  return async () => {
    const sessionExists = await oktaAuth.session?.exists();
    if (!sessionExists) {
      return;
    }
    const hasAccess = await hasAccessToApp();
    if (!hasAccess) {
      return;
    }
    oktaAuth.tokenManager.clear();
    const tokenResponse = await oktaAuth.token.getWithoutPrompt();
    await oktaAuth.handleLoginRedirect(tokenResponse.tokens);
  };
}

export function useDeleteRedundantSession() {
  const { oktaAuth } = useOktaAuth();
  const hasAccessToApp = useHasAccessToApp();
  return async () => {
    const sessionExists = await oktaAuth.session?.exists();
    if (!sessionExists) {
      return false;
    }
    const hasAccess = await hasAccessToApp();
    // if current okta session has access to the app, then we don't want to delete it
    if (hasAccess) {
      return false;
    }
    const sessionClosed = await oktaAuth.session.close();
    return !!sessionClosed;
  };
}

export const useHasAccessToApp = () => {
  const { clientId, issuer } = useAuthConfig();
  return async () => {
    const baseUrl: string = issuer?.split('/oauth2')[0];
    if (!clientId || !baseUrl) {
      return false;
    }
    try {
      const response = await fetch(`${baseUrl}/api/v1/users/me/appLinks`, {
        credentials: 'include',
        method: 'GET',
        mode: 'cors',
      });
      const apps = await response.json();
      const app = apps.find((a: any) => a.appInstanceId === clientId);
      return !!app;
    } catch {
      return false;
    }
  };
};
